import { createAction } from '@reduxjs/toolkit'

import { Modal, ModalName } from '../@types'

export const openModal = createAction<Modal>('modal/openModal')
export const closeModal = createAction<ModalName>('modal/closeModal')
export const closeAllModal = createAction('modal/closeAllModal')
